import { useMutation } from "@apollo/client/react";import { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CREATE_PERIODO } from '../../../data/graphQL/mutations/Periodos/createPeriodo';

import toast from 'react-hot-toast';
import moment from 'moment';
import { RenderInputsRowByType } from '../../../components/formGroupGenerator/RenderInputRowByType';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const GestionPeriodoCreationModal = ({
  years,
  months,
  fechaComienzo,
  allowedWrite,
  disabledNuevo,
  buttonLoading,
  getPeriodos
}) => {
  const [periodo, setPeriodo] = useState({});

  const [openModal, setOpenModal] = useState(false);

  const handleChange = (name, value) => {
    setPeriodo((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  useEffect(() => {
    if (!!fechaComienzo) {
      const fechaInicio = moment(fechaComienzo).subtract(1, 'days');
      const mesAnterior = fechaInicio.month() + 1; // Mes en formato 1-12
      const anioAnterior = fechaInicio.year();

      const nuevoMes = mesAnterior === 12 ? 1 : mesAnterior + 1;
      const nuevoAnio = mesAnterior === 12 ? anioAnterior + 1 : anioAnterior;

      setPeriodo((prevDatos) => ({
        ...prevDatos,
        fechaDesde: moment(fechaComienzo).format('YYYY-MM-DD'),
        mes: nuevoMes,
        anio: nuevoAnio
      }));
    }
  }, [fechaComienzo, openModal]);

  const handleOpenModal = () => setOpenModal(true);

  const handleClose = () => {
    setOpenModal(false);
    setPeriodo({});
  };

  const [crearPeriodo, { loading: guardarLoading }] = useMutation(CREATE_PERIODO, {
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        mes: periodo.mes,
        anio: periodo.anio,
        fechaDesde: periodo.fechaDesde,
        fechaHasta: periodo.fechaHasta,
        activo: true,
        fechaModificacion: null,
        idUsuarioModificacion: null
      }
    },
    onCompleted: (data) => {
      setOpenModal(false);
    }
  });

  const generalLoading = useMemo(() => {
    return buttonLoading || guardarLoading;
  }, [buttonLoading, guardarLoading]);

  const newInput = useMemo(() => {
    return {
      displayName: 'Nuevo Periodo',
      name: 'nuevoPeriodo',
      type: 'button',
      isLoading: buttonLoading,
      variant: 'contained',
      col: 30,
      disabled: disabledNuevo,
      onClick: () => handleOpenModal()
    };
  }, [buttonLoading, disabledNuevo]);

  const isValid = () => {
    const errorMessages = [];

    const { mes, anio, fechaDesde, fechaHasta } = periodo;

    if (!mes)
    errorMessages.push('Debe ingresar Mes. \n');

    if (!anio)
    errorMessages.push('Debe ingresar Año. \n');

    if (!fechaDesde || !fechaHasta || !moment(fechaDesde).isValid() || !moment(fechaHasta).isValid() || moment(fechaDesde).isAfter(moment(fechaHasta)))
    errorMessages.push('Debe ingresar fechas válidas y asegurarse de que "Fecha Desde" sea anterior a "Fecha Hasta".\n');

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  const handleGuardar = async () => {
    if (isValid()) {
      try {
        await toast.promise(
          crearPeriodo(), {
            loading: 'Creando Periodo...',
            success: 'Periodo creado.',
            error: 'Ocurrió un error al intentar crear el Periodo.'
          });
        await getPeriodos();
      } catch (error) {
        toast.error('Ocurrió un error al intentar crear el Periodo.');
      } finally {
        handleClose();
      }
    }
  };

  const updatedFields = useMemo(() => {
    return structuredClone(inputs).
    map((input) => {
      const updatedInput = { ...input };
      switch (input.name) {
        case 'mes':
          updatedInput.options = months;
          break;
        case 'anio':
          updatedInput.options = years;
          break;
        default:
          break;
      }
      if (!allowedWrite) {
        updatedInput.disabled = true;
      }
      return updatedInput;
    });
  }, [
  fechaComienzo,
  allowedWrite,
  years,
  months,
  periodo]
  );

  return <>
        <RenderInputsRowByType
      input={newInput}
      value={null}
      handleChange={null} />
    
        <CustomDialog
      maxWidth='sm'
      fullWidth
      onCancel={() => handleClose()}
      onAccept={() => handleGuardar()}
      acceptLoading={generalLoading}
      open={openModal}
      cancelText='Cerrar'
      acceptText='Guardar'
      title={'Agregar nuevo periodo'}>
      
            <Grid container spacing={3}>
                {updatedFields.map((input, index) =>
        <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}>
                        <RenderInputByTypeMobile
            key={`input-${input.name}-index-${index}`}
            input={input}
            handleChange={handleChange}
            value={periodo[input.name]} />
          
                    </Grid>
        )}
            </Grid>
        </CustomDialog>
    </>;

};

const inputs = [
{
  displayName: 'Mes',
  name: 'mes',
  type: 'select',
  disabled: true,
  col: 6
},
{
  displayName: 'Año',
  name: 'anio',
  type: 'select',
  disabled: true,
  col: 6
},
{
  displayName: 'Fecha Desde',
  name: 'fechaDesde',
  type: 'date',
  disabled: true,
  col: 6
},
{
  displayName: 'Fecha Hasta',
  name: 'fechaHasta',
  type: 'date',
  disabled: false,
  col: 6
}];